import Stats from "./stats";

export default Stats;
